import $ from 'jquery';
import { CartDrawerIO } from './io';
import { formatMoney } from '../core/shopify/format-money';
const slides = document.querySelectorAll('.LandingpageCarousel-slide');
const container = $('#js-cart-drawer');
const rawIo = container.find('script[type="application/json"]').first().text() || '{}';
const { moneyFormat  } = CartDrawerIO.create(JSON.parse(rawIo));
const logErrors = function(err) {
    console.error(err);
};
async function updateSlide(e, slide) {
    const targetSwatch = e.target;
    const allSwatches = slide.querySelectorAll('.js-coll-swatch');
    //const HPCar = document.querySelector('.LandingpageCarousel') as HTMLElement
    if (targetSwatch instanceof HTMLElement) {
        if (targetSwatch.hasAttribute('js-color-swatches') && !targetSwatch.classList.contains('active')) {
            if (allSwatches) {
                allSwatches.forEach((elem)=>{
                    elem.classList.remove('active');
                });
            }
            targetSwatch.classList.add('active');
            const productUrl = targetSwatch.getAttribute('prod-url');
            if (productUrl) {
                await fetch(productUrl + '.js').then((res)=>res.json()).then((data)=>{
                    /*  initQuickview(data)
          if (HPCar) {
            const div = document.createElement('div')
            div.classList.add('QuickView-overlay')
            div.setAttribute('product-handle', data.handle)
            HPCar.insertBefore(div, HPCar.firstChild)
          }*/ const productName = data.title, productPrice = data.price, productImg = data.images[2] || data.images[1] || data.images[0] || data.featured_image, productHandle = data.handle;
                    const imageElem = slide.querySelector('.LandingpageCarousel-image');
                    const priceElem = slide.querySelector('.LandingpageCarousel-price');
                    const nameElem = slide.querySelector('.LandingpageCarousel-title');
                    const quickviewElem = slide.querySelector('.LandingpageCarousel-btn');
                    if (imageElem && imageElem instanceof HTMLElement) {
                        imageElem.style.backgroundImage = `url(${productImg})`;
                    }
                    if (priceElem && priceElem instanceof HTMLElement) {
                        priceElem.innerText = formatMoney(productPrice, moneyFormat || '{{amount}}');
                    }
                    if (nameElem && nameElem instanceof HTMLElement) {
                        nameElem.innerHTML = `<a href="${productUrl}">${productName}</a>`;
                    }
                    if (quickviewElem) {
                        quickviewElem.setAttribute('car-handle', productHandle);
                    }
                });
            }
        }
    }
}
export const init = async function() {
    slides.forEach((elem)=>{
        if (elem instanceof HTMLElement) {
            const colorlist = elem.querySelector('.LandingpageCarousel-swatchesLine');
            if (colorlist) {
                colorlist.addEventListener('click', (e)=>updateSlide(e, elem), false);
            }
        }
    });
};
